"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactsScope = void 0;
let ContactsScope = exports.ContactsScope = void 0;
(function (_ContactsScope) {
  let Type = /*#__PURE__*/function (Type) {
    Type["ALL_CONTACTS"] = "scope:contacts";
    Type["CONTACT_EMPLOYEES"] = "scope:contact_employees";
    Type["CONTACT_ORGANISATIONS"] = "scope:contact_organisations";
    Type["CAMPAIGN_RECIPIENTS"] = "scope:campaign_recipients";
    Type["CAMPAIGN_REPORT"] = "scope:campaign_report";
    return Type;
  }({});
  _ContactsScope.Type = Type;
})(ContactsScope || (exports.ContactsScope = ContactsScope = {}));